import { all } from 'redux-saga/effects'
import { authSagas } from '../../common/auth/authSagas'
import { integrationSagas } from '../../common/integration/integrationSagas'
import { languageSagas } from '../../common/language/languageSagas'
import { routerSaga } from '../../common/Routes/RouterSaga'
import { activityManagementSagas } from '../../views/Activity/store/ActivitySagas'
//import { benefitsSagas } from '../../views/Benefits/store/BenefitsSagas'
import { benefitsManagementSagas } from '../../views/ChallengeAdmin/store/ChallengeAdminSagas'
import { forgotPasswordSagas } from '../../views/ForgotPassword/store/ForgotPasswordSagas'
import { loginSagas } from '../../views/Login/store/LoginSagas'
import { signUpSagas } from '../../views/SignUp/store/SignUpSagas'
import { registerUserSagas } from '../../views/RegisterUser/store/RegisterUserSagas'
import { resetPasswordSagas } from '../../views/ResetPassword/store/ResetPasswordSagas'
import { settingsSagas } from '../../views/Settings/store/SettingsSagas'
import { statisticsSagas } from '../../views/Statistics/store/StatisticsSagas'
import { progressSagas } from '../../views/Progress/store/ProgressSagas'
import { userManagementSagas } from '../../views/UserManagement/store/UserManagementSagas'
import { companyRankingSagas } from '../../views/CompanyRanking/store/CompanyRankingSagas'
import { googleSignInSagas } from '../../components/YumGoogleSignIn/store/GoogleSignInSagas'
import { appleSignInSagas } from '../../components/YumAppleSignIn/store/AppleSignInSagas'
import { dashboardSagas } from '../../views/Dashboard/store/DashboardSagas'
//import { chatSagas } from '../../views/ChallengeChat/store/ChatSagas'

export function* appSagas() {
  yield all([
    authSagas(),
    integrationSagas(),
    loginSagas(),
    signUpSagas(),
    userManagementSagas(),
    settingsSagas(),
    registerUserSagas(),
    activityManagementSagas(),
    benefitsManagementSagas(),
    routerSaga(),
    languageSagas(),
    statisticsSagas(),
    dashboardSagas(),
    progressSagas(),
    //benefitsSagas(),
    forgotPasswordSagas(),
    resetPasswordSagas(),
    companyRankingSagas(),
    googleSignInSagas(),
    appleSignInSagas(),
    //chatSagas(),
  ])
}
